import type { ReactNode } from 'react';

export const symbol_speed_2x: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M405-277H265q-24.75 0-42.37-17.63Q205-312.25 205-337v-115q0-24 18-42t42-18h110v-111H235q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h140q24 0 42 18t18 42v111q0 24-18 42t-42 18H265v115h140q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5Zm235-157-77 139q-4.29 7.06-10.71 11.03-6.43 3.97-14.15 3.97Q521-280 513-294t0-28l91-164-85-152q-8-14-.5-28t24.64-14q7.72 0 14.15 3.97 6.42 3.97 10.71 11.03l72 128 71-128q4.29-7.06 10.71-11.03 6.43-3.97 14.15-3.97Q753-680 761-666t0 28l-85 152 92 165q8 14 0 27.5T742.76-280q-7.76 0-13.76-3.71-6-3.7-10-10.29l-79-140Z"
		/>
	</svg>
);
